import React from 'react';
import PropTypes from 'prop-types';

import cls from 'classnames';
import styles from './Loader.scss';

export default function Loader({ isLoading, isMobileLayout }) {
  return (
    <div
      className={cls(styles.loader, isMobileLayout, {
        [styles.isVisible]: isLoading,
      })}
    />
  );
}
